import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export type ActivityRouteSearch = {
  portfolioId?: string;
};

export const Route = createFileRoute("/_app/activity")({
  validateSearch: (search: Record<string, unknown>): ActivityRouteSearch => {
    const portfolioId =
      typeof search.portfolioId === "string" && search.portfolioId.length > 0
        ? search.portfolioId
        : undefined;
    return portfolioId ? { portfolioId } : {};
  },
  head: () => ({
    meta: [{ title: m.activity_page_meta_title() }],
  }),
});
